
  <section class="cmn-innerpage-wrapper attendance">
    <div class="inner-content">
      <div class="common-noimage-tab-wrapper">
          <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onTabChange($event)">
              <!-- Mat Tab One -->
              <mat-tab>
                  <ng-template mat-tab-label>
                      <h2 class="leave-tab-title">Attendance</h2>
                  </ng-template>
                  <div class="leave-history-table">
                      <app-attendance #attendanceComponent></app-attendance>
                  </div>


              </mat-tab>
          </mat-tab-group>
      </div>
     
  </div>

  </section>
